<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.path"></router-view> <!--可以被缓存-->
    </keep-alive>
    <!---->
    <router-view v-if="!$route.meta.keepAlive"  :key="$route.path"></router-view>
  </div>
</template>
<script>
  export default {
    name: 'App',
    data () {
      return {}
    },
    methods: {

    }
  }
</script>

<style lang="less">
.size{
  width: 100%;
  height: 100%;
}
html,body{
  .size;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
</style>



// WEBPACK FOOTER //
// src/App.vue